import AOS from "aos";

import { initSlider, initHomeSlider } from "./_slider";
import { initEventSlider } from "./_event-slider";
import { initHeadroom } from "./_headroom";
import { nav } from "./_nav";
import { initTransitions } from "./_transitions.js";
import { initVideoReveal } from "./_video-reveal";
import { initVideoCustom } from "./_video-custom";
import { carousel3d } from "./_carousel3d";

import {initResponsiveIframes} from './_gawura_responsive_iframes.js';

const app = document.querySelector("#app");
const header = document.querySelector(".site-header");

// init headroom
let headroom = (headroom = initHeadroom(header));
headroom.init();

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    var bootstrap = require("bootstrap");
} catch (e) {}

(function ($) {
    // inits
    jQuery(function ($) {
        initSlider($);
        initHomeSlider($);
        nav($, bootstrap);
        initEventSlider($);
        carousel3d($);
		initVideoReveal($);
		initVideoCustom($)
    });

	// make this available globally
	window.AOS = AOS;

    AOS.init({
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 120, // offset (in px) from the original trigger point
        delay: 250, // values from 0 to 3000, with step 50ms
        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: "ease", // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    // init transitions
    initTransitions($);

    // small delay to allow css dimensions to become accurate
    setTimeout(function () {
        onWindowResize($);
    }, 50);

    // Init Lightcase
    $('a[data-rel^=lightcase]').lightcase({
        maxWidth: 1024,
        maxHeight: 768
    });

    $('a[href$=".jpg"]').lightcase({
        maxWidth: 1024,
        maxHeight: 768
    });

    // debounce window resize
    var timeout = 0;
    $(window).on("resize", (event) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            onWindowResize($);
        }, 300);
    });

	function onWindowResize($) {
		refreshHeaderOffset($);
		// Refresh AOS
    	AOS.refreshHard();
	}

    function refreshHeaderOffset($) {
        // Our header is positioned fixed, so let's offset the app element to the headers height
        if (headroom && document.body.classList.contains("microsite")) {
            headroom.offset = header.offsetHeight;
            app.style.paddingTop = `${header.offsetHeight}px`;
        }

        if (headroom && document.body.classList.contains("no-featured-image")) {
            headroom.offset = header.offsetHeight;
            app.style.paddingTop = `${header.offsetHeight}px`;
        }
    }


	// focus search input on dropdown open
	$('.search-dropdown').on('shown.bs.dropdown', function () {
		setTimeout(function(){
			$('#primary-search-field', '.search-dropdown')[0].focus();
		}, 500);
	});

	// gawura iframes
	// console.log("Initializing responsive iframes...");
	initResponsiveIframes($);

	// Refresh AOS
    AOS.refreshHard();

})(jQuery);